import React, { Suspense, useEffect, useState } from "react";
import Loader from "../component/Loader";
import { organizationLogin } from "../services/auth";
import { setOnLoginEmployeeInfo, getOrgDetails } from "../services/globalData";
const MainPage = React.lazy(() => import("../app/main"));
const OrganizationUnderReview = React.lazy(() => import("../app/platform/OrganizationUnderReview"));

function Main() {
  const [orgLoginStatus, setOrgLoginStatus] = useState(false);
  // Set when the server says the organisation has not been approved. The owner
  // is signed in and their organisation exists — the gate is on what it may
  // DO — so this is a waiting room rather than a bounce back to login, which
  // would read as "your password is wrong".
  const [review, setReview] = useState(null);

  useEffect(() => {
    const checkOrganizationInfo = async () => {
      if (orgLoginStatus === false) {
        // Guard direct /app entry: if the org's onboarding wasn't finished
        // (explicit false), send the user back to the Select Plan step rather
        // than into the dashboard. Legacy orgs (undefined) pass through.
        if (getOrgDetails()?.onboardingComplete === false) {
          sessionStorage.setItem("setSignUpPage", "orgPurpose");
          window.location.pathname = "/signup";
          return;
        }
        const res = await organizationLogin();
        const { success, data, code, message } = res || {};
        if (!success) {
          // A tenant route refused because the organisation is not approved.
          // Belt to the braces below: this catches a status that changed since
          // the token was minted.
          if (code === "org_pending" || code === "org_rejected") {
            setReview({ rejected: code === "org_rejected", reason: message });
          } else {
            window.location.pathname = "/login";
          }
          return;
        }
        setOnLoginEmployeeInfo(data);

        // The access-token response carries the organisation's approval status,
        // because that route deliberately sits ABOVE the approval gate —
        // somebody has to be able to sign in and be told they are waiting.
        // Checked here rather than letting the dashboard render and fail on
        // every call it makes. Absent means an organisation from before the
        // gate existed, which passes, exactly as onboardingComplete does above.
        const org = getOrgDetails() || {};
        if (org.approvalStatus === "pending" || org.approvalStatus === "rejected") {
          setReview({
            rejected: org.approvalStatus === "rejected",
            reason: org.approvalNote,
          });
          return;
        }
        setOrgLoginStatus(true);
      }
    };
    checkOrganizationInfo();
  }, []);

  return (
    <>
      <Suspense fallback={<Loader />}>
        {review ? (
          <OrganizationUnderReview
            rejected={review.rejected}
            reason={review.reason}
            companyName={getOrgDetails()?.companyName}
          />
        ) : orgLoginStatus ? (
          <MainPage />
        ) : (
          <Loader />
        )}
      </Suspense>
    </>
  );
}

export default Main;
